import React from 'react';
import 'twin.macro';
import SearchEtablissement from 'containers/MesAnneesScolaires/SearchEtablissement';
import { StepWrapper } from 'containers/Demarrage/components/StepWrapper';
import { useUpdateDemarrage } from 'containers/Demarrage/queries/useUpdateDemarrage';
import { Divider } from 'components/Divider';
import Button from 'components/Buttons/Button';
import { ArrowRightIcon as ArrowRight } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { DemarrageData } from 'containers/Demarrage/types';
import { StateSelector } from 'containers/MesAnneesScolaires/SearchEtablissement/StateSelector';

interface Props {
  demarrageData: DemarrageData;
  onManual: () => void;
}

export function USEcoleStep(props: Props) {
  const { demarrageData, onManual } = props;
  const update = useUpdateDemarrage();
  const { t } = useTranslation(['onboarding', 'schoolyearSettings']);
  return (
    <StepWrapper
      title={t('onboarding:school.title')}
      currentStep="ecole"
      nextDisabled={!demarrageData.etablissementNcesSchoolId}
    >
      <div tw="mb-8">
        <StateSelector
          extraLarge
          value={demarrageData?.zoneId || 'CA'}
          onChange={z => update({ zoneId: z })}
        />
      </div>
      <SearchEtablissement
        size="lg"
        country="US"
        helperText={t(
          'schoolyearSettings:schoolGeneral.searchSchool.inputLabelUS',
        )}
        state={demarrageData?.zoneId || 'CA'}
        onManual={onManual}
        onSelect={async ({ selectedEtablissement, query, nbResults }) => {
          await update({
            etablissementNcesSchoolId: selectedEtablissement?.id,
            searchQueries: [
              ...(demarrageData?.searchQueries || []),
              { query, nbResults },
            ],
          });
        }}
        selectedEtablissementId={demarrageData?.etablissementNcesSchoolId}
      />

      {(demarrageData?.userRoles?.includes('autre') ||
        demarrageData?.userRoles?.includes('2nd degré')) && (
        <>
          <Divider
            bgColor="gray-100"
            tw="my-8"
            title={t('onboarding:school.or')}
          />
          <div tw="text-center">
            <Button
              onClick={onManual}
              extralarge
              outlined
              rightIcon={ArrowRight}
            >
              {t('onboarding:school.goManually')}
            </Button>
          </div>
        </>
      )}
    </StepWrapper>
  );
}
